export default __webpack_public_path__ + "static/perfect-pair.light-dd83dd3fa31d45311e427f0528b8391c.png";